import React, { useContext, useMemo } from "react";
import { useStyles } from "../RCACompliance.styles";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ComplianceBar from "../../components/ComplianceBar";
import { RCAAPComplianceContext } from "contexts/RCAAPComplianceContext/RCAAPComplianceContext";
import moment from "moment";
import { RCAAPComplianceEntity } from "entities/RCA/RCAAPComplianceEntity/RCAAPComplianceEntity";
import { ComplianceBarReferences } from "../../components/ComplianceBar/ComplianceBarReferences.view";

const RCAComplianceWholeMill = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { filters } = useContext(RCAAPComplianceContext);
    const argsFilters = useMemo(
        () => ({
            date: moment().subtract(Number(filters.periodOption), "day").startOf("day").toISOString(),
            meetingTypeIds: filters.meetingTypeIds,
            totalMeetingTypes: filters.totalMeetingTypes,
        }),
        [filters],
    );
    const { rcaComplianceByMill } = RCAAPComplianceEntity.GetRCAComplianceByMill(argsFilters);

    const barData = useMemo(
        () =>
            rcaComplianceByMill.map((rca) => ({
                completedOnTimeAmount: rca.completed_on_time,
                pendingAmount: rca.pending,
                completedLateAmount: rca.completed_late,
                pendingLateAmount: rca.pending_late,
                total: rca.total_rcas_by_period,
            })),
        [rcaComplianceByMill],
    );

    return (
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography variant="rcaTitle" className={classes.cardTitle}>
                    {t("rca.compliance.rca_compliance.whole_mill.title")}
                </Typography>
            </div>
            <div className={classes.cardBody}>
                <ComplianceBar data={barData} />
                {barData.length > 0 && <ComplianceBarReferences />}
            </div>
        </div>
    );
};

export default RCAComplianceWholeMill;
